import React, { useRef } from "react";
import styled, { useTheme } from "styled-components";

import { displayAvatar } from "../../Helpers/chatHelper/AvatarHelper";
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg"
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg"


const ForwardModalChatElement = ({ data, selected, handleContactSelect }) => {
  const ref = useRef();
  const theme = useTheme();
  let name = data?.other_participants[0]?.name;

  if (data.group != null) {
    name = data.group.name;
  }
  if (data.quick_chat) {
    name = data.quick_chat_name;
  }

  return (
    <ChatListElementContainer onClick={(e) => handleContactSelect(data)}>
      <FoundContactAvatar>{displayAvatar(data)}</FoundContactAvatar>
      <Text>
        <PhoneNumber>
          <h1>{name}</h1>
        </PhoneNumber>
        <CheckWrapper>
          {selected ?
            <CheckedWrapper>
              <Check />
            </CheckedWrapper> :
            <CheckEmptyWrapper>
              <CheckEmpty />
            </CheckEmptyWrapper>}
        </CheckWrapper>
      </Text>
    </ChatListElementContainer>
  );
};

export default ForwardModalChatElement;
const ChatListElementContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 16px;
  gap: 10px;
  cursor: pointer;
  z-index: 1;

`;

const FoundContactAvatar = styled.div`
  display: flex;
  height:35px;
  width:35px;
  max-width: 35px;
  min-height: 35px;
  min-width: 35px;
  max-height: 35px;
  border-radius: 100%;
  position:relative;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius:100%;
  }

  svg{
    object-fit: cover;
   width: 100%;
   height: 100%;
 }
`;
const Text = styled.div`
  display: flex;
  gap: 4px;
  overflow: hidden;
  width: 100%;
  position: relative;
  height: 100%;
`;
const PhoneNumber = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  h1 {
    color:  ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }

  h2 {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme.menu.selectedTextColor};
  }
`;

const CheckWrapper = styled.div`
display:flex;
margin-left:auto;
align-items:center;

svg{
fill:transparent;
color:transparent;
}
`

const CheckedWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.background};
fill:${({ theme }) => theme.check.checkSign};
}
`
const CheckEmptyWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.border};
stroke:${({ theme }) => theme.check.checkSign};
}
`